(function () {
  var DEFER_CLASS = 'defer-gorgias-chat';
  var LOADER_SELECTOR =
    'script[data-gorgias-loader-chat],script[data-gorgias-loader-convert],script[data-gorgias-loader-mailto-replace],script[src*="smile-loader.js"]';
  var INTERACTION_EVENTS = ['scroll', 'mousemove', 'touchstart', 'keydown', 'click'];
  var SMILE_MAIN_SCRIPT = 'https://js.smile.io/v1/smile-shopify.js';

  var queued = [];
  var activated = false;
  var pageLoaded = document.readyState === 'complete';
  var interacted = false;
  var loaderObserver = null;

  document.documentElement.classList.add(DEFER_CLASS);

  function queueScript(script) {
    queued.push({
      src: script.src,
      defer: script.defer,
      attrs: Array.prototype.slice.call(script.attributes).filter(function (attr) {
        return attr.name !== 'src';
      }),
    });
    script.parentNode.removeChild(script);
  }

  function collectLoaders() {
    document.querySelectorAll(LOADER_SELECTOR).forEach(queueScript);
  }

  function injectSmileMainIfNeeded() {
    if (document.readyState !== 'complete') return;
    if (!window.Shopify || !window.Shopify.shop) return;
    if (document.querySelector('script[src*="smile-shopify.js"]')) return;

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src =
      SMILE_MAIN_SCRIPT + '?shop=' + encodeURIComponent(window.Shopify.shop);
    document.head.appendChild(script);
  }

  function activate() {
    if (activated) return;
    activated = true;
    if (loaderObserver) {
      loaderObserver.disconnect();
      loaderObserver = null;
    }
    document.documentElement.classList.remove(DEFER_CLASS);

    queued.forEach(function (item) {
      var script = document.createElement('script');
      item.attrs.forEach(function (attr) {
        script.setAttribute(attr.name, attr.value);
      });
      script.src = item.src;
      if (item.defer) script.defer = true;
      document.head.appendChild(script);
    });

    queued = [];
    injectSmileMainIfNeeded();
  }

  function maybeActivate() {
    if (!pageLoaded || !interacted) return;
    activate();
  }

  collectLoaders();

  if ('MutationObserver' in window) {
    loaderObserver = new MutationObserver(function (mutations) {
      if (activated) return;
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1 || node.tagName !== 'SCRIPT') return;
          if (!node.matches(LOADER_SELECTOR)) return;
          queueScript(node);
        });
      });
    });

    loaderObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  window.addEventListener('load', function () {
    pageLoaded = true;
    maybeActivate();
  });

  INTERACTION_EVENTS.forEach(function (eventName) {
    window.addEventListener(
      eventName,
      function () {
        interacted = true;
        maybeActivate();
      },
      { once: true, passive: true }
    );
  });
})();
